import { Link } from "react-router-dom";
import { Lock, LogOut, RotateCcw } from "lucide-react";
import { Logo } from "@/components/Logo";
import { startGoogleLogin } from "@/components/AuthCallback";
import { GoogleMark } from "@/components/reviews/ReviewParts";

export const AdminShell = ({ user, logout, children }) => (
  <div className="min-h-screen bg-ink text-slate-50" data-testid="admin-page">
    <header className="border-b border-line glass sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="admin-back-home" className="flex items-center gap-2.5 group">
          <Logo size={30} /><span className="font-display text-lg">PEPE <span className="text-cyan-400">AVS</span>
            <span className="font-mono-ui text-[10px] uppercase text-slate-500 ml-3">Admin</span></span>
        </Link>
        {user && <button onClick={logout} data-testid="admin-logout-button" className="flex items-center gap-2 px-3 py-2 rounded-full border border-line text-sm hover:border-slate-500 transition-colors">
          <LogOut size={14} />Déconnexion
        </button>}
      </div>
    </header>
    <main className="max-w-6xl mx-auto px-5 sm:px-8 py-10 min-w-0 break-words">{children}</main>
  </div>
);

export const AdminLogin = ({ error, retry }) => {
  return (
    <section className="max-w-sm mx-auto mt-16 glass border border-line rounded-2xl p-6 sm:p-8 space-y-5" data-testid="admin-login-form">
      <div className="text-center"><Lock size={28} className="mx-auto text-cyan-400" />
        <h1 className="font-display uppercase text-3xl mt-3" data-testid="admin-login-heading">Espace Pépé</h1>
        <p className="text-sm text-slate-400 mt-2" data-testid="admin-access-notice">Accès réservé au compte Google du propriétaire.</p>
      </div>
      {error && <p role="alert" data-testid="admin-google-auth-error" className="text-sm text-red-300 border border-red-400/30 rounded-lg p-3 break-words">{error}</p>}
      <button type="button" onClick={() => startGoogleLogin("admin")} data-testid="admin-google-login-button" className="w-full inline-flex justify-center items-center gap-3 px-4 py-3.5 rounded-full bg-white text-slate-900 font-bold text-sm hover:scale-[1.02] active:scale-95 transition-transform"><GoogleMark size={18} />Se connecter avec Google</button>
      {retry && <button type="button" onClick={retry} data-testid="admin-session-retry-button" className="w-full inline-flex items-center justify-center gap-2 text-sm text-slate-400 hover:text-cyan-300 transition-colors"><RotateCcw size={14} />Vérifier à nouveau</button>}
      <Link to="/" data-testid="admin-login-back-site" className="block text-center text-xs text-slate-400 hover:text-cyan-300 transition-colors">Retour au site</Link>
    </section>
  );
};

export const AdminLoadState = ({ resource, name }) => {
  if (resource.loading) return <p data-testid={`admin-${name}-loading`} className="py-8 text-slate-400">Chargement…</p>;
  if (!resource.error) return null;
  return <div role="alert" data-testid={`admin-${name}-error`} className="py-8 text-red-300">
    Chargement impossible.
    <button onClick={resource.reload} data-testid={`admin-${name}-retry`} className="ml-3 inline-flex items-center gap-2 underline"><RotateCcw size={14} />Réessayer</button>
  </div>;
};